import { useKV } from "@quark/kits";
import PeopleIcon from "../../icons/people";
import Popup from "../popup";
import styles from "./index.module.scss";

const JoinCommunity = () => {
  const { data: teacherQrcode } = useKV("teacher");

  return (
    <Popup
      content={
        <div className={styles.content}>
          <img src={teacherQrcode?.value} alt="" />
          <div className={styles.tips}>微信扫一扫加入 PythonTip 社区</div>
        </div>
      }
    >
      <div className={styles.button}>
        <PeopleIcon />
        加入社区
      </div>
    </Popup>
  );
};

export default JoinCommunity;
